import router from '@/router'
import store from '@/store'
import { getToken, getType } from '@/util/auth' // get token from cookie
import NProgress from 'nprogress'

const whiteList = [ '/login', '/resiger', '/emailActive', '/registerSuccess', '/forgetPwd' ]
router.beforeEach(async (to, from, next) => {
  // determine whether the user has logged in
  const hasToken = getToken()
  const hasType = getType()
  if (hasToken) {
    if (to.path === '/') {
      next({ path: '/licenseManager' })
      NProgress.done()
    } else if (hasType === 'company' && to.path === '/fileUpload') {
      next({ path: '/licenseManager' })
      NProgress.done()
    } else {
      // get user info
      // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
      await store.dispatch('user/getInfo')
      // generate accessible routes map based on roles
      await store.dispatch('permission/generateRoutes')
      // // dynamically add accessible routes
      // router.addRoutes(accessRoutes)

      // hack method to ensure that addRoutes is complete
      // set the replace: true, so the navigation will not leave a history record
      // next({ ...to, replace: true })
      next() // hack方法 确保addRoutes已完成
    }
  } else {
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next()
    } else {
      next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
})



// WEBPACK FOOTER //
// ./src/permission.js